// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 12625, offsets 194563:194850. Structure and names inferred from code, not screenshots.

import * as React from "react";
function useMediaQuery(e) {
  let [t, i] = (0, React.useState)(false);
  return (
    (0, React.useEffect)(() => {
      let t = window.matchMedia(e),
        n = (e) => i(e.matches);
      return (
        i(t.matches),
        t.addEventListener("change", n),
        () => t.removeEventListener("change", n)
      );
    }, [e]),
    t
  );
}
export { useMediaQuery };
